import { DetailSection } from '@periscopes/general';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeTagList } from '@periscopes/general/tags';
import React from 'react';
export const FieldTags = ({ index, tagIds }) => {
    const title = `${PERISCOPE_TAB_TYPES.TAGS} (${tagIds.length})`;
    return (React.createElement(DetailSection, { spacing: 'small', title: title },
        React.createElement(PeriscopeTagList, { parentIndex: index, tagIds: tagIds })));
};
